<template>
  <div class="side-nav">
    <div class="user-info" ref="userInfo">
      <div class="user-img">
        <img :src="userData.avatar" alt="">
      </div>
      <h2 class="name">{{userData.name}}</h2>
      <p>{{userData.mobile}}</p>
      <p>{{userData.telephone}}</p>
      <div style="clear:both;margin-top:15px;">
        <p v-for="d,i in departmentArr">{{d}}</p>
        <p v-if="userData.position">职务：{{userData.position}}</p>
      </div>
    </div>

    <contacts-nav v-if="contacts"></contacts-nav>

    <div class="nav" v-else>
      <div class="main-cont-link" @click="goIndex()" :class="mainType=='index'?'cur':''">
        <div class="nav-list-title">
          <i class="iconfont icon-zhuye"></i>首页动态
        </div>
      </div>

      <!-- 管理系统左侧导航 -->
      <div class="nav-list" ref="navList">
        <div class="nav-list-item" v-for="nav in navArr" :class="(loopType(nav.type)||showAll) ? 'cur':''">
          <div class="nav-list-title" v-if="backNavRole(nav.lackKey)" @click="navToggle($event)">
            <i class="iconfont icon-arrowdown-copy" :class="(loopType(nav.type)||showAll) ? 'normal':''"></i>
            <i class="iconfont" :class="nav.icon"></i>{{nav.name}}
          </div>
          <ul class="nav-list-link" :class="(loopType(nav.type)||showAll) ? 'show':''" :data-show="loopType(nav.type)">
            <li v-for="sub in nav.child" v-if="backRole(sub.roleKey) && mustManager(sub)">
              <div class="title">
                <a v-if="sub.link" href="javascript:void(0)" @click="setTypeName(nav.type, sub.type, sub.link)"
                  class="nav-item" :class="loopType(nav.type)&&subType==sub.type?'cur':''">
                  <i class="iconfont" :class="sub.icon"></i>
                  <span class="name">{{sub.name}}</span>
                  <span v-if="sub.num" class="nav-tip-num">{{ sub.num }}</span>
                </a>

                <span v-else class="nav-item" :class="loopType(nav.type)&&subType==sub.type?'cur':''">
                  <i class="iconfont" :class="sub.icon"></i>
                  <span class="name">{{sub.name}}</span>
                  <span v-if="sub.num" class="nav-tip-num">{{ sub.num }}</span>
                </span>
              </div>
              <div class="type-list">
                <div class="type-list-item" v-for="tSub in sub.child"
                  :class="loopType(nav.type)&&subType==tSub.type?'cur':''"
                  v-if="backRole(tSub.roleKey) && mustManager(sub)">
                  <a href="javascript:void(0)" @click="setTypeName(nav.type, tSub.type, tSub.link)">
                    <span class="iconfont icon-jiantou"></span>{{tSub.name}}
                  </a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>



  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import ContactsNav from './ContactsNav'
  export default {
    components: {
      ContactsNav
    },
    mixins: [Role],
    created() {},
    methods: {
      // 获取最新的会议条数及审批条数
      getTipsNum() {
        ajax.get('/msg/tips/num', "", (res) => {
          this.$store.commit('set_tipNum', res.vo)
          this.setTipNum(res.vo)
        })
      },

      goIndex() {
        this.$router.push('/')
      },
      // 设置TYPENAME
      setTypeName(mainType, subType, link) {
        if (!link) {
          return
        }
        this.$store.commit('SET_TYPE', {
          main: mainType[0],
          sub: subType
        })
        this.$router.push(link)
      },
      loopType(type) {
        let _state = 0
        for (var i = 0; i < type.length; i++) {
          if (type[i] == this.mainType) {
            _state = 1
          }
        }
        return _state
      },
      // 点击打开收缩子nav
      navToggle(e) {
        let _target = e.target,
          _firstChild = _target.firstChild,
          _nextNode = _target.nextElementSibling,
          _parent = _target.parentNode
        if (!_firstChild || !_nextNode || !_parent) {
          return
        }

        // console.log(e.target.nextElementSibling)
        if (_nextNode.classList.contains('show')) {
          _nextNode.classList.remove('show')
          _firstChild.classList.remove('normal')
          _parent.classList.remove('cur')
        } else {
          _nextNode.classList.add('show')
          _firstChild.classList.add('normal')
          _parent.classList.add('cur')
        }
      },
      setTipNum(num) {
        // console.log(1)

        let tn = num ? num : this.tipNum
        if (!tn) {
          return
        }
        // 与我相关
        let my = this.navArr[0]
        // 我的会议
        if (my.child[0] && my.child[0].name == "我的会议") {
          my.child[0].num = tn.conferenceNum
        }
        // 我的审批
        if (my.child[4] && my.child[4].name == "我的审批") {
          my.child[4].num = tn.spNum
        }
      },

      // 计算当前显示的左侧菜单
      JudgeNav() {
        this.navArr = this.defaultNavArr
        let _now_url = this.nowRouterUrl
        if (_now_url.match("Contacts")) {
          this.contacts = true
        } else {
          this.contacts = false
          if (_now_url.match("Set/")) {
            // 系统设置
            this.navArr = this.setNavArr
            // 默认展开
            this.showAll = true
          } else if (_now_url.match("Storage/")) {
            // 材料仓库
            this.navArr = this.StorageNavArr
          } else if ((_now_url.match('Personnel/') || _now_url.match('Administrative/') || _now_url.match('Meeting/') ||
              _now_url.match('Seal/') || _now_url.match('Car/') || _now_url.match('Notice/')) && !_now_url.match(
              'User/')) {
            // 行政人事
            this.navArr = this.AdministrativeArr
          } else if (_now_url.match("Asset/")) {
            // 固定资产
            this.navArr = this.OperateteArr
            // 默认展开
            this.showAll = true
          } else if (_now_url.match("Consumable/")) {
            // 易耗品管理
            this.navArr = this.ConsumableArr
            // 默认展开
            this.showAll = true
          } else {
            // 默认、工程相关
            this.getTipsNum()
          }
        }
      },
    },
    computed: {
      ...mapState({
        mainType: state => state.main.mainType,
        subType: state => state.main.subType,
        nowRouterUrl: state => state.main.nowRouterUrl,
        userData: state => state.main.userData,
        tipNum: state => state.main.tipNum,
      })
    },
    mounted() {
      // 设置左侧导航
      this.JudgeNav()

      if (this.userData) {
        this.departmentArr = this.userData.department.split(",")
      }

      // 显示待办number
      this.setTipNum()

      // 高度计算
      this.$nextTick(() => {
        let _h = document.documentElement.clientHeight
        let _max_h = document.body.clientHeight
        // console.log(_h + "::" + _max_h)
        if (this.$refs.userInfo) {
          let _nav_h = _h - 80 - this.$refs.userInfo.clientHeight - 40 - 15 * 4
          if (!this.$refs.navList) {
            return
          }
          this.$refs.navList.style.height = _nav_h + "px"
        }
      })

    },
    watch: {
      nowRouterUrl() {
        // 设置左侧导航
        this.JudgeNav()
      },
      tipNum() {
        this.setTipNum()
      },
    },
    data() {
      return {
        // 仓库目录权限相关
        managerHouses: [],

        showAll: false,
        // tipNum: [],

        departmentArr: [],
        contacts: false,
        navArr: [],
        // 行政人事
        AdministrativeArr: [{
          icon: 'icon-huiyishi',
          name: '会议管理',
          type: ['meeting'],
          link: '',
          child: [{
            name: '会议列表',
            type: 'meetinglist',
            link: '/Meeting/List',
            icon: 'icon-huiyi',
            roleKey: 'CM_1'
          }, {
            name: '会议申请审批列表',
            type: 'meetingapprovallist',
            link: '/Meeting/ApprovalList',
            icon: 'icon-huiyi',
            roleKey: 'CM_1'
          }, {
            name: '会议室管理',
            type: 'meetingroomlist',
            link: '/Meeting/Room/List',
            icon: 'icon-huiyishi1',
            roleKey: 'CM_2'
          }]
        }, {
          icon: 'icon-tongzhi',
          name: '通知公告',
          type: ['notice'],
          link: '',
          child: [{
            name: '新建通知公告',
            type: 'create',
            link: '/Notice/create',
            icon: 'icon-tongzhi',
            roleKey: 'TZ_1'
          }, {
            name: '通知公告列表',
            type: 'list',
            link: '/Notice/List',
            icon: 'icon-liebiao1',
            roleKey: 'TZ_2'
          }, {
            name: '我的通知公告列表',
            type: 'mylist',
            link: '/Notice/MyList',
            icon: 'icon-liebiao1',
          }]
        }, {
          icon: 'icon-cheliangguanli-',
          name: '车辆管理',
          type: ['car'],
          link: '',
          lackKey: 'CL',
          child: [{
            name: '车辆购置审批',
            type: 'buyCarList',
            link: '/Car/BuyList',
            icon: 'icon-cheliangguanli',
            roleKey: 'CL_1',
          }, {
            name: '车辆使用审批',
            type: 'useCarList',
            link: '/Car/UseList',
            icon: 'icon-cheliangguanli',
            roleKey: 'CL_2',
          }, {
            name: '车辆维修',
            type: 'repairCarList',
            link: '/Car/RepairList',
            icon: 'icon-cheliangweixiubaoyang',
            roleKey: 'CL_3',
          }, {
            name: '车辆派遣',
            type: 'dispatchCarList',
            link: '/Car/DispatchList',
            icon: 'icon-cheliangguohu',
            roleKey: 'CL_4',
          }, {
            name: '作业车辆调度',
            type: 'controlCarList',
            link: '/Car/ControlList',
            icon: 'icon-chelianggongchengqichepeijian',
            roleKey: 'CL_5',
          }, {
            name: '车辆管理奖惩审批',
            type: 'rewardsCarList',
            link: '/Car/RewardsList',
            icon: 'icon-cheliangxinxi',
            roleKey: 'CL_6',
          }, {
            name: '车辆列表',
            type: 'carList',
            link: '/Car/List',
            icon: 'icon-liebiao1',
            roleKey: 'CL_7',
          }]
        }, {
          icon: 'icon-icon-test',
          name: '印章管理',
          type: ['seal'],
          link: '',
          child: [{
            name: '印章列表',
            type: 'seallist',
            link: '/Seal/List',
            icon: 'icon-liebiao1',
            roleKey: 'SM_1'
          }, {
            name: '使用/外带申请列表',
            type: 'sealuselist',
            link: '/Seal/Use/List',
            icon: 'icon-yinzhang',
            roleKey: 'SM_2'
          }, {
            name: '刻制/销毁申请列表',
            type: 'sealoperatelist',
            link: '/Seal/Operate/List',
            icon: 'icon-yinzhang',
            roleKey: 'SM_3'
          }, {
            name: '印章审批说明列表',
            type: 'sealreadmelist',
            link: '/Seal/ReadMe/List',
            icon: 'icon-xitong',
            roleKey: 'SM_4'
          }]
        }, {
          icon: 'icon-HRrenshirenshiguanli',
          name: '人事管理',
          type: ['personnel'],
          lackKey: 'RS',
          child: [{
            icon: 'icon-wj-qjd',
            name: '请假/休假申请',
            type: ['vacationList'],
            link: '/Personnel/Vacation/List',
            roleKey: 'RS_1',
          }, {
            icon: 'icon-wj-qjd',
            name: '考勤未签到申请',
            type: ['kqList'],
            link: '/Personnel/Kq/List',
            roleKey: 'RS_1',
          }, {
            icon: 'icon-yuangongtiaodongshenqingbiao',
            name: '人员调动审批',
            type: ['transferList'],
            link: '/Personnel/Transfer/List',
            roleKey: 'RS_3',
          }, {
            icon: 'icon-dangan',
            name: '员工花名册',
            type: ['list'],
            link: '/Personnel/List',
            roleKey: 'RS_4',
          }, ]
        }, ],
        // 易耗品
        ConsumableArr: [{
          icon: 'icon-wupin',
          name: '低值易耗品管理',
          type: ['consumable'],
          lackKey: 'YH',
          child: [{
            icon: 'icon-ruku',
            name: '物品入库',
            type: [],
            link: '',
            roleKey: 'YH_1',
            child: [{
              name: '物品入库登记',
              type: 'inList',
              link: '/Consumable/InList',
              roleKey: 'YH_1',
            }, {
              name: '物品入库明细列表',
              type: 'inDetailList',
              link: '/Consumable/InDetailList',
              roleKey: 'YH_1',
            }]
          }, {
            icon: 'icon-chuku',
            name: '物品领用',
            type: [],
            link: '',
            roleKey: 'YH_2',
            child: [{
              name: '物品领用申请',
              type: 'useList',
              link: '/Consumable/UseList',
              roleKey: 'YH_2',
            }, {
              name: '物品出库明细列表',
              type: 'useDetailList',
              link: '/Consumable/UseDetailList',
              roleKey: 'YH_2',
            }, {
              name: '物品出库汇总表',
              type: 'UseApplyDetailList',
              link: '/Consumable/UseApplyDetailList',
              roleKey: 'YH_6',
            }]
          }, {
            icon: 'icon-tuihuo',
            name: '物品退库',
            type: [],
            link: '',
            roleKey: 'YH_2',
            child: [{
              name: '物品退库申请',
              type: 'backList',
              link: '/Consumable/BackList',
              roleKey: 'YH_2',
            }, {
              name: '物品退库明细列表',
              type: 'backDetailList',
              link: '/Consumable/BackDetailList',
              roleKey: 'YH_2',
            }]
          }, {
            icon: 'icon-kucunpandian-',
            name: '物品盘点',
            type: [],
            link: '',
            roleKey: 'YH_3',
            child: [{
              name: '物品盘点登记',
              type: 'inventoryList',
              link: '/Consumable/InventoryList',
              roleKey: 'YH_3',
            }, {
              name: '物品盘点明细列表',
              type: 'inventoryDetailList',
              link: '/Consumable/InventoryDetailList',
              roleKey: 'YH_3',
            }]
          }, {
            icon: 'icon-kucun1',
            name: '实时库存查询',
            type: 'realTimeList',
            link: '/Consumable/Detail',
            roleKey: 'YH_4',
          }, {
            icon: 'icon-caigoudingdan',
            name: '物品申购列表',
            type: 'consumableApplyList',
            link: '/Consumable/ApplyList',
            roleKey: 'YH_5',
          }, {
            icon: 'icon-caigoudingdan',
            name: '物品申购汇总列表',
            type: 'consumableApplyDetailList',
            link: '/Consumable/ApplyDetailList',
            roleKey: 'YH_6',
          }, {
            icon: 'icon-caigoudan',
            name: '采购计划表列表',
            type: 'consumablePlanApplyList',
            link: '/Consumable/PlanApplyList',
            roleKey: 'YH_6',
          }, {
            icon: 'icon-navicon-jldwsz',
            name: '计量单位列表',
            type: 'unitList',
            link: '/Consumable/UnitList',
            roleKey: 'YH_8',
          }, {
            icon: 'icon-gongyingshang',
            name: '供应商列表',
            type: 'consumableSupplierList',
            link: '/Consumable/SupplierList/2',
            roleKey: 'YH_8',
          }, {
            icon: 'icon-cailiaopinpai',
            name: '易耗品信息管理',
            type: 'consumableList',
            link: '/Consumable/ConsumableInfoList',
            roleKey: 'YH_7',
          }, {
            icon: 'icon-type',
            name: '易耗品类别管理',
            type: 'consumableTypeList',
            link: '/Consumable/ConsumableTypeList',
            roleKey: 'YH_8',
          }, ]
        }],
        // 资产运营
        OperateteArr: [{
          icon: 'icon-zichanguanli',
          name: '固定资产管理',
          type: ['asset'],
          lackKey: 'AS',
          child: [{
              name: '与我相关的资产',
              icon: 'icon-liebiao1',
              type: 'myList',
              link: '/Asset/MyList',
            }, {
              name: '资产入库财务确认',
              icon: 'icon-liebiao1',
              type: 'myFinanceList',
              link: '/Asset/MyFinanceList',
            }, {
              name: '资产入库',
              icon: 'icon-rukuguanli',
              type: 'assetcreate',
              link: '/Asset/Create',
              roleKey: 'AS_1'
            }, {
              name: '资产列表',
              icon: 'icon-liebiao1',
              type: 'assetlist',
              link: '/Asset/List',
              roleKey: 'AS_2'
            }, {
              name: '资产变更记录',
              icon: 'icon-change',
              type: 'assetchangelist',
              link: '/Asset/ChangeList',
              roleKey: 'AS_4'
            }, {
              name: '资产维修记录',
              icon: 'icon-weixiujilu',
              type: 'assetrepairlist',
              link: '/Asset/RepairList',
              roleKey: 'AS_5'
            }, {
              name: '资产盘点',
              icon: 'icon-liebiao1',
              type: 'assetInventory',
              link: '/Asset/Inventory/List',
              roleKey: 'AS_2'
            }, {
              name: '资产调拨',
              icon: 'icon-navicon-dbd',
              type: 'allotList',
              link: '/Asset/AllotList',
              roleKey: 'AS_7'
            }, {
              name: '资产处置',
              icon: 'icon-ziyuanjieyong',
              type: 'handleList',
              link: '/Asset/HandleList',
              roleKey: 'AS_6'
            }, {
              name: '资产分类设置',
              icon: 'icon-classify_icon',
              type: 'assettype',
              link: '/Asset/Type',
              roleKey: 'AS_3'
            }, {
              name: '供应商列表',
              icon: 'icon-gongyingshang',
              type: 'assetSupplierList',
              link: '/Asset/SupplierList/0',
              roleKey: 'AS_3'
            }, {
              name: '资产属性列表',
              icon: 'icon-shuxingliebiaoxiangqing',
              type: 'assetAttribute',
              link: '/Asset/Attribute',
              roleKey: 'AS_3'
            },
            // {
            // name: '资产所属部门',
            // icon: 'icon-bumen',
            // type: 'assetDept',
            // link: '/Asset/Dept',
            // roleKey: 'AS_3'
            // },
          ]
        }, ],
        // 材料仓库
        StorageNavArr: [{
          icon: 'icon-cangku',
          name: '材料/仓库管理',
          type: ['storage'],
          child: [{
              icon: 'icon-ruku',
              name: '材料入库',
              type: [],
              link: '',
              roleKey: 'ST_4',
              child: [{
                name: '材料入库登记',
                type: 'inList',
                link: '/Storage/MaterialInList',
                roleKey: 'ST_4',
                // mustManager: true,
              }, {
                name: '材料入库明细列表',
                type: 'materialInDetailList',
                link: '/Storage/MaterialInDetailList',
                roleKey: 'ST_4',
                // mustManager: true,
              }]
            }, {
              icon: 'icon-chuku',
              name: '材料领用',
              type: [],
              link: '',
              roleKey: 'ST_1',
              child: [{
                name: '材料领用申请',
                type: 'materialUseList',
                link: '/Storage/MaterialUseList',
                roleKey: 'ST_1',
              }, {
                name: '材料出库单列表',
                type: 'materialUseOutList',
                link: '/Storage/MaterialUseOutList',
                roleKey: 'ST_1',
              }, {
                name: '材料出库明细列表',
                type: 'materialUseDetailList',
                link: '/Storage/MaterialUseDetailList',
                roleKey: 'ST_1',
              }]
            }, {
              icon: 'icon-chuku',
              name: '材料调拨',
              type: [],
              link: '',
              roleKey: 'ST_15',
              child: [{
                name: '材料调拨登记',
                type: 'materialAllotList',
                link: '/Storage/MaterialAllotList',
                roleKey: 'ST_15',
              }, ]
            }, {
              icon: 'icon-chuku',
              name: '维修/新购出库登记列表',
              type: 'materialOutList',
              link: '/Storage/MaterialOutList',
              roleKey: 'ST_11',
              mustManager: true,
            }, {
              icon: 'icon-baobiaofenxi',
              name: '工程/客户材料使用汇总',
              type: 'MaterialUseDetailListByCustomer',
              link: '/Storage/MaterialUseDetailListByCustomer',
              roleKey: 'ST_1',
            }, {
              icon: 'icon-tuihuo',
              name: '材料退库',
              type: [],
              link: '',
              roleKey: 'ST_1',
              child: [{
                name: '材料退库申请',
                type: 'materialBackList',
                link: '/Storage/MaterialBackList',
                roleKey: 'ST_1',
              }, {
                name: '材料业务性退库',
                type: 'materialBackForceList',
                link: '/Storage/MaterialBackForceList',
                roleKey: 'ST_16',
              }, {
                name: '材料退库单列表',
                type: 'materialBackAllList',
                link: '/Storage/MaterialBackAllList',
                roleKey: 'ST_1',
              }, {
                name: '材料退库明细列表',
                type: 'materialBackDetailList',
                link: '/Storage/MaterialBackDetailList',
                roleKey: 'ST_1',
              }]
            }, {
              icon: 'icon-kucunpandian-',
              name: '材料盘点',
              type: [],
              link: '',
              mustManager: true,
              child: [{
                name: '材料盘点登记',
                type: 'materialInventoryList',
                link: '/Storage/MaterialInventoryList',
                mustManager: true,
              }, {
                name: '材料盘点明细列表',
                type: 'materialInventoryDetailList',
                link: '/Storage/MaterialInventoryDetailList',
                mustManager: true,
              }]
            }, {
              icon: 'icon-kucun1',
              name: '仓库实时库存查询',
              type: 'realTimeList',
              link: '/Storage/Detail',
              // mustManager: true,
              roleKey: 'ST_14'
            }, {
              icon: 'icon-baobiaofenxi',
              name: '材料月度报表',
              type: 'materialReport',
              link: '/Storage/MaterialReport',
              roleKey: 'ST_2'
            },
            {
              icon: 'icon-liebiao1',
              name: '仓库列表',
              type: 'roomlist',
              link: '/Storage/Room/List',
              roleKey: 'ST_5'
            }, {
              icon: 'icon-navicon-jldwsz',
              name: '计量单位列表',
              type: 'unitList',
              link: '/Storage/UnitList',
              roleKey: 'ST_6'
            }, {
              icon: 'icon-gongyingshang',
              name: '供应商列表',
              type: 'storageSupplierList',
              link: '/Storage/SupplierList/1',
              roleKey: 'ST_7'
            }, {
              icon: 'icon-cailiaopinpai',
              name: '材料信息管理',
              type: 'storageMaterialList',
              link: '/Storage/MaterialList',
              roleKey: 'ST_8'
            }, {
              icon: 'icon-type',
              name: '材料类别管理',
              type: 'materialTypeList',
              link: '/Storage/MaterialTypeList',
              roleKey: 'ST_9'
            },
          ]
        }, ],
        // 系统设置
        setNavArr: [{
          icon: 'icon-permissions-user',
          name: '权限设置',
          type: ['role'],
          child: [{
            icon: 'icon-quanxianguanli',
            name: '权限管理',
            type: 'userGroup',
            link: '/Set/UserGroup',
          }, {
            icon: 'icon-quanxianyingyongguanli',
            name: '权限组设置',
            type: 'roleList',
            link: '/Set/Role',
          }]
        }, {
          icon: 'icon-xitong',
          name: '系统设置',
          type: ['setting'],
          child: [{
            icon: 'icon-custom-constructi',
            name: '系统审批节点设置',
            type: 'approvalSet',
            link: '/Set/Approval',
          }, {
            icon: 'icon-custom-constructi',
            name: '系统固定人员设置',
            type: 'nodeUser',
            link: '/Set/Node',
          }, {
            icon: 'icon-zuhe',
            name: '工程项目组设置',
            type: 'team',
            link: '/Set/Team',
          }]
        }],
        // 默认导航
        defaultNavArr: [{
          icon: 'icon-gongzuo',
          name: '与我相关',
          type: ['user', 'index'],
          child: [{
            icon: 'icon-huiyishi',
            name: '我的会议',
            type: 'meetinglist',
            link: '/User/Meeting/List',
            num: 0,
          }, {
            icon: 'icon-tongzhi',
            name: '我的通知公告',
            type: 'noticelist',
            link: '/User/Notice/List',
          }, {
            icon: 'icon-icon-test',
            name: '我的印章',
            type: 'seallist',
            link: '/User/Seal/List',
          }, {
            icon: 'icon-xiangmuguanli',
            name: '我的工程/项目',
            type: 'projectlist',
            link: '/User/Project/List',
          }, {
            icon: 'icon-hetong',
            name: '我的合同',
            type: 'contractlist',
            link: '/User/Contract/List',
          }, {
            icon: 'icon-caigoudingdan',
            name: '我的采购',
            type: 'purchaselist',
            link: '/User/Purchase/List',
          }, {
            icon: 'icon-shenpi',
            name: '我的审批',
            type: "approvallist",
            link: '/User/Approval/List',
            num: 0,
          }]
        }, {
          icon: 'icon-xiangmuguanli',
          name: '项目管理',
          type: ['project', 'index'],
          lackKey: 'PM',
          child: [{
            icon: 'icon-icon-test1',
            name: '项目申请',
            type: 'create',
            link: '/Project/Create',
            roleKey: 'PM_1'
          }, {
            icon: 'icon-liebiao1',
            name: '项目列表',
            type: 'list',
            link: '/Project/List',
            roleKey: 'PM_2'
          }, {
            icon: 'icon-liebiao1',
            name: '微型项目列表(A类)',
            type: 'alist',
            link: '/Project/A/List',
            roleKey: 'PM_2'
          }, {
            icon: 'icon-liebiao1',
            name: '微型项目列表(B类)',
            type: 'slist',
            link: '/Project/S/List',
            roleKey: 'PM_2'
          }, {
            icon: 'icon-pay-circle',
            name: '工程项目款项/支付总览',
            type: 'pay',
            link: '/Project/PayOverview/List',
            roleKey: 'PM_3'
          }, {
            icon: 'icon-tongji',
            name: '工程项目进度总览',
            type: 'statistics',
            link: '/Project/Statistics/List',
            roleKey: 'PM_3'
          }]
        }, {
          icon: 'icon-caigoudingdan',
          name: '采购管理',
          type: ['purchase'],
          lackKey: 'CG',
          child: [{
            icon: 'icon-caigoudan',
            name: '采购申请',
            type: 'purchaseApply',
            link: '/Purchase/Apply',
            roleKey: 'CG_1',
          }, {
            icon: 'icon-liebiao',
            name: '采购列表',
            type: 'purchaseList',
            link: '/Purchase/List',
            roleKey: 'CG_1',
          }, {
            icon: 'icon-caigoudan',
            name: '子公司内部采购申请',
            type: 'purchaseApplySub',
            link: '/Purchase/ApplySub',
            roleKey: 'CG_1',
          }, {
            icon: 'icon-liebiao',
            name: '子公司内部采购列表',
            type: 'purchaseListSub',
            link: '/Purchase/ListSub',
            roleKey: 'CG_1',
          }, {
            icon: 'icon-xiangmushouxubeian',
            name: '采购备案审批',
            type: 'purchaseRecord',
            link: '/Purchase/Record',
            roleKey: 'CG_2',
          }, {
            icon: 'icon-beian',
            name: '采购备案列表',
            type: 'purchaseRecordList',
            link: '/Purchase/Record/List',
            roleKey: 'CG_2',
          }, {
            icon: 'icon-beian',
            name: '供应商准入申请',
            type: 'purchaseSupplierList',
            link: '/Purchase/supplier/List',
            roleKey: 'CG_3',
          }]
        }, {
          icon: 'icon-hetong',
          name: '合同管理',
          type: ['contract'],
          lackKey: 'CT',
          child: [{
            icon: 'icon-icon-test1',
            name: '新建合同',
            type: 'create',
            link: '/Contract/Create',
            roleKey: 'CT_1'
          }, {
            icon: 'icon-liebiao1',
            name: '合同列表',
            type: 'list',
            link: '/Contract/List',
            roleKey: 'CT_2'
          }]
        }, {
          icon: 'icon-pay-circle',
          name: '支付管理',
          type: ['pay'],
          lackKey: 'PAY',
          child: [{
            icon: 'icon-icon-test1',
            name: '新建款项支付',
            type: 'create',
            link: '/Pay/Create',
            roleKey: 'PAY_1'
          }, {
            icon: 'icon-liebiao1',
            name: '支付审批列表',
            type: 'list',
            link: '/Pay/List',
            roleKey: 'PAY_2'
          }, {
            icon: 'icon-17',
            name: '款项类别设置',
            type: 'type',
            link: '/Pay/Type',
            roleKey: 'PAY_3'
          }]
        }, {
          icon: 'icon-wenjianjia',
          name: '文件柜',
          type: ['disk'],
          link: '',
          child: [{
            name: '文件列表',
            type: 'list',
            link: '/Disk/List',
            icon: 'icon-liebiao1',
          }, ]
        }, {
          icon: 'icon-tongyongleimorenshitu',
          name: '通用审批',
          type: ['common'],
          child: [{
            icon: 'icon-icon-test1',
            name: '通用审批申请',
            type: 'commonApply',
            link: '/Common/Apply',
          }, {
            icon: 'icon-liebiao',
            name: '通用审批列表',
            type: 'commonList',
            link: '/Common/List',
          }, ]
        }, ]
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/SideNav.vue